// eslint-disable-next-line no-restricted-imports
import type { CountryIso2Code } from '../../constants/index.ts'

type CountryIso2CodeType = `${CountryIso2Code}`

export interface ContactPerson {
  /**
   * Contact person's postal code of residence
   * @type {string}
   * @memberof ContactPerson
   */
  address?: string | null
  /**
   * Contact person's city of residence
   * @type {string}
   * @memberof ContactPerson
   */
  city?: string | null
  /**
   *
   * @type {CountryIso2Code}
   * @memberof ContactPerson
   */
  country?: CountryIso2CodeType | null
  /**
   * Contact person's email address
   * @type {string}
   * @memberof ContactPerson
   */
  email: string
  /**
   * Contact person's first name
   * @type {string}
   * @memberof ContactPerson
   */
  firstName: string
  /**
   * Set the prefered language to use when contacting the contact person for booking related communication(s).
   * @type {string}
   * @memberof ContactPerson
   */
  lang?: ContactPersonLang
  /**
   * Contact person's last name
   * @type {string}
   * @memberof ContactPerson
   */
  lastName: string
  /**
   *
   * @type {CountryIso2Code}
   * @memberof ContactPerson
   */
  nationality: CountryIso2CodeType
  /**
   *
   * @type {ContactPersonOrganization}
   * @memberof ContactPerson
   */
  organization?: ContactPersonOrganization | null
  /**
   * Contact person's phone number
   * @type {string}
   * @memberof ContactPerson
   */
  phone: string
  /**
   * Contact person's remarks
   * @type {string}
   * @memberof ContactPerson
   */
  remarks?: string
  /**
   * Title of the contact person
   * @type {string}
   * @memberof ContactPerson
   */
  salutation?: ContactPersonSalutation
  /**
   * Contact person's state of residence
   * @type {string}
   * @memberof ContactPerson
   */
  state?: string | null
  /**
   * Contact person's postal code of residence
   * @type {string}
   * @memberof ContactPerson
   */
  zipCode?: string | null
}

export enum ContactPersonLangEnum {
  DeDe = 'de-DE',
  EnUs = 'en-US',
  EsEs = 'es-ES',
  FrFr = 'fr-FR',
  ItIt = 'it-IT',
  NlNl = 'nl-NL',
  PtPt = 'pt-PT',
}

type ContactPersonLang = `${ContactPersonLangEnum}`

export enum ContactPersonSalutationEnum {
  Dr = 'dr',
  Mr = 'mr',
  Mrs = 'mrs',
  Ms = 'ms',
  NotSpecified = 'notSpecified',
  Prof = 'prof',
}

type ContactPersonSalutation = `${ContactPersonSalutationEnum}`

export interface ContactPersonOrganization {
  /**
   * Address of the organization
   * @type {string}
   * @memberof ContactPersonOrganization
   */
  address: string
  /**
   * City of the organization
   * @type {string}
   * @memberof ContactPersonOrganization
   */
  city: string
  /**
   *
   * @type {CountryIso2Code}
   * @memberof ContactPersonOrganization
   */
  country: CountryIso2CodeType
  /**
   * Name of the organization
   * @type {string}
   * @memberof ContactPersonOrganization
   */
  name: string
  /**
   * State of the organization
   * @type {string}
   * @memberof ContactPersonOrganization
   */
  state?: string | null
  /**
   * VAT Number of the organization
   * @type {string}
   * @memberof ContactPersonOrganization
   */
  vatNumber?: string | null
  /**
   * ZIP Code of the organization
   * @type {string}
   * @memberof ContactPersonOrganization
   */
  zipCode: string
}
